import React, { useEffect, useState } from 'react';
import { toast, ToastContainer } from "react-toastify";

import "common/css/master.css";
import Header from "common/js/header/header";
import Loader from "common/components/Loader";

import { getPatternListSvc, getQuestionTypeListSvc } from './questionPaperPatternSvc';
import QuestionPaperPatternTbl from './questionPaperPatternTbl';
import PatternSlider from './patternSlider';

function QuestionPaperPatternCtrl() {

    const [loader, setLoader] = useState("none");
    const [opacity, setOpacity] = useState(1);
    const [lstPattern, setLstPattern] = useState([]);
    const [patternId, setPatternId] = useState(0);
    const [flgPatternSliderVisible, setFlgPatternSliderVisible] = useState(false);
    const [lstQusType, setLstQusType] = useState([]);
    const [key, setKey] = useState(0);
    const [patternObj, setPatternObj] = useState({});




    useEffect(() => {
        // console.log("QuestionPaperPatternCtrl called");
        getPatternList();
        getQuestionTypeList();
    }, []);

    const getPatternList = () => {
        // console.log("getPatternList called");
        setLoader("block");
        setOpacity(0.5);
        getPatternListSvc(patternListResponse);
    }


    const patternListResponse = (data) => {
        // console.log("patternListResponse called, data", data);
        if (data.status === "Success") {
            setLstPattern(data.lstPattern);
        } else if (data.status === "Failure") {
            handleServiceError(data.message);
        } else {
            toast.error("Service failed " + data.error);
        }
        setLoader("none");
        setOpacity(1);
    }

    const getQuestionTypeList = () => {
        // console.log("getQuestionTypeList called");
        setLoader("block");
        setOpacity(0.5);
        getQuestionTypeListSvc(questionTypeListResponse);
    }


    const questionTypeListResponse = (data) => {
        // console.log("questionTypeListResponse called, data", data);
        if (data.status === "Success") {
            setLstQusType(data.lstQusType);
        } else if (data.status === "Failure") {
            handleServiceError(data.message);
        } else {
            toast.error("Service failed " + data.error);
        }
        setLoader("none");
        setOpacity(1);
    }

    const handleServiceError = (svcMsg) => {
        if (svcMsg === "You are not Logged In") {
            toast.error("You are not logged in. Redirecting to login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else if (svcMsg === "Server Timed Out, Login Again") {
            toast.error("Server timed out. Redirecting to login page...");
            setTimeout(() => {
                window.location.href = "/";
            }, 2000);
        } else {
            toast.error(svcMsg);
        }
    };

    const addPattern = () => {
        // console.log("addPattern called");
        setPatternObj({});
        setPatternId(0);
        openPatternSlider();
    }

    const editPattern = (pattern) => {
        // console.log("editPattern called, pattern", pattern);
        setPatternObj(pattern);
        setPatternId(pattern.patternId);
        openPatternSlider();
    }

    const openPatternSlider = () => {
        // console.log("openPatternSlide called");
        setFlgPatternSliderVisible(true);
    }

    const closePatternSlider = () => {
        // console.log("closePatternSlider called");
        setFlgPatternSliderVisible(false);
    }

    const updateKey = () => {
        setKey(prevKey => prevKey + 1);
    }

    return (
        <div >
            <Header />
            <ToastContainer autoClose={3000} hideProgressBar />
            <Loader loader={loader} position="fixed" />
            <div className="col-md-12 col-xs-12 col-centered padding-remove"
                style={{
                    cursor: (loader === "none") ? 'pointer' : 'none',
                    pointerEvents: (loader === "none") ? 'auto' : 'none',
                    opacity: opacity
                }}>
            </div >
            <div className="col-md-10 col-sm-10 col-xs-10 col-centered padding-remove" style={{ marginTop: "50px" }}>
                <div className="col-md-11 col-sm-11 col-xs-11  padding-remove" >
                    <QuestionPaperPatternTbl
                        lstPattern={lstPattern}
                        patternId={patternId}
                        setPatternId={setPatternId}
                        editPattern={editPattern}
                    />
                </div>
                <div className="col-md-1 col-sm-1 col-xs-1 text-center padding-remove" >
                    <span
                        id="addContent"
                        title="Add Pattern"
                        className="addIcon glyphicon glyphicon-plus-sign"
                        onClick={() => addPattern()}
                    ></span>
                </div>
            </div>
            {
                flgPatternSliderVisible ?
                    <div className="slider1-80">
                        <PatternSlider
                            patternId={patternId}
                            closeSlider={closePatternSlider}
                            updateKey={updateKey}
                            lstQusType={lstQusType}
                        />
                    </div >
                    : null
            }
        </div >
    )
}

export default QuestionPaperPatternCtrl;




